/* Yali – Home page FW26
   Carica solo il video giusto (desktop o mobile) e lo cambia
   se la finestra attraversa il breakpoint dei 767px. */
(function () {
  var mq = window.matchMedia('(max-width: 767px)');

  function setSource(video) {
    var mode = mq.matches ? 'mobile' : 'desktop';
    if (video.dataset.yaliMode === mode) return;

    var src = video.dataset['src' + (mode === 'mobile' ? 'Mobile' : 'Desktop')];
    var type = video.dataset['type' + (mode === 'mobile' ? 'Mobile' : 'Desktop')];
    var poster = video.dataset['poster' + (mode === 'mobile' ? 'Mobile' : 'Desktop')];
    if (!src) return;

    video.dataset.yaliMode = mode;
    while (video.firstChild) video.removeChild(video.firstChild);

    var source = document.createElement('source');
    source.src = src;
    if (type) source.type = type;
    video.appendChild(source);
    if (poster) video.poster = poster;

    video.muted = true;
    video.load();

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (video.dataset.autoplay === 'true' && !reduceMotion) {
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }
  }

  function init(root) {
    (root || document).querySelectorAll('[data-yali-video]').forEach(setSource);
    initCarousels(root);
  }

  /* Carosello: trascinamento con il mouse su desktop
     (touch e trackpad scorrono già in modo nativo) */
  function initCarousels(root) {
    (root || document).querySelectorAll('[data-yali-carousel] .yali-carousel__track').forEach(function (track) {
      if (track.dataset.yaliReady) return;
      track.dataset.yaliReady = '1';

      var down = false, startX = 0, startScroll = 0, moved = false;

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false;
        startX = e.clientX;
        startScroll = track.scrollLeft;
      });

      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 5) {
          moved = true;
          track.classList.add('is-dragging');
        }
        if (moved) track.scrollLeft = startScroll - dx;
      });

      function end() {
        if (!down) return;
        down = false;
        if (moved) {
          setTimeout(function () { track.classList.remove('is-dragging'); }, 0);
        }
      }
      track.addEventListener('pointerup', end);
      track.addEventListener('pointerleave', end);
      track.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
    });
  }


  function onChange() {
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  if (mq.addEventListener) {
    mq.addEventListener('change', onChange);
  } else if (mq.addListener) {
    mq.addListener(onChange);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
